<template>
  <div>
    <header-component></header-component>

    <div class="signin-wrapper">
        <div class="signin-container g-width-400">
            <div class="signin-header mb-3">
                <h1><strong>Login to <br>Champions for Sight</strong></h1>
            </div>
            <form @submit.prevent="validateBeforeReview()">

                <!-- Signin -->
                <div id="signin">
                <div class="u-shadow-v35 g-bg-white rounded g-px-20 g-py-20">
                    <div class="g-mb-20">
                    <label class="g-color-text-light-v1 g-font-size-16 g-font-weight-500">Email</label>
                    <div class="input-group">
                        <span class="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
                        <i class="icon-education-166 u-line-icon-pro"></i>
                        </span>
                        <input name="email"  oninput="this.value = this.value.toLowerCase()" type="email" v-model="Account.EmailAddress" class="form-control login_input g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12" v-validate="'required|email'" data-vv-as="email" placeholder="John@gmail.com">
                    </div>
                    <p class="error-message" v-show="errors.has('email')">{{ errors.first('email') }}</p>
                    </div>
                    <div class="g-mb-20">
                    <label class="g-color-text-light-v1 g-font-size-16 g-font-weight-500">Password</label>
                    <div class="input-group">
                        <span class="input-group-addon g-width-50 g-brd-secondary-light-v2 g-bg-secondary g-rounded-right-0">
                        <i class="icon-finance-135 u-line-icon-pro"></i>
                        </span>
                        <input name="password" type="password" v-model="Account.Password" class="form-control login_input g-brd-secondary-light-v2 g-bg-secondary g-bg-secondary-dark-v1--focus g-rounded-left-0 g-px-20 g-py-12" v-validate="'required'" data-vv-as="password" placeholder="**********">
                    </div>
                    <p class="error-message" v-show="errors.has('password')">{{ errors.first('password') }}</p>
                    </div>
                    <p v-show="isLoginfalse && !isForActivation" class="error-message">{{errorMessage}}</p>
                    <p v-show="isLoginfalse && isForActivation" class="error-message">
                        You need to activate your account using the activation link sent to your email. <a class="btn btn-default hover" style="padding: 0" v-on:click="ShowResendModal()">Click here</a> to resend your activation email.
                    </p>
                    <p class="error-message" v-if="isGenericError">An unexpected error has occurred. Please try again in a few minutes.</p>
                    <div class="d-flex justify-content-between align-items-center">
                    <a class="btn btn-default hover g-font-size-16" style="padding: 0" v-on:click="ShowModal()">Forgot Password?</a>
                    <button type="submit" v-bind:disabled="isLoginLoading" class="btn btn-default login_button u-shadow-v33 g-color-white g-bg-main g-bg-primary--hover g-font-size-16 rounded g-px-25 g-py-">Log In
                        <span v-if="isLoginLoading"><img src="../../../../static/img/loading.gif" style="width: 25px"/></span>
                    </button>
                    </div>

                </div>
                <div class="u-shadow-v35 g-bg-white rounded g-py-10 g-mt-20">
                    <div class="text-center">
                        <p class="g-color-text-light-v1 g-font-size-16 g-font-weight-500">Do not have an account?</p>
                        <a  v-on:click="RedirectToSignUp()" class="btn g-font-size-16 u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-13">Sign Up</a>

                        <a v-on:click="RouterRedirect('Demo')" class="btn g-font-size-16 u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-25 g-py-13">View Demo</a>

                    </div>
                </div>
                <div class="text-center">

                </div>
                </div>
            <!--<a class="btn btn-default login_button" id="signup-link" :to="{name: 'Registration'}">Create Account</a>-->
            </form>
        </div>
    </div>

    <footer-component></footer-component>

    <div v-if="isModalShown">
        <forgot-password @clicked="ShowModal()"></forgot-password>
    </div>
    <div v-if="isResendModalShown">
        <resend-activation @clicked="ShowResendModal()"  v-bind:RequestEmail="Account.EmailAddress"></resend-activation>
    </div>
    <!-- Wufoo form disabled - no longer showing help modal on login page -->
    <!-- <help-form style="margin-top:100px;" @closeWufoo="ToggleWufoo()" :isLoggedIn="'FALSE'" :Account="Account"></help-form> -->
</div>
</template>
<script>
import HeaderComponent from "@/components/shared/HeaderComponent";
import FooterComponent from "@/components/shared/FooterComponent";
import ForgotPassword from "@/components/home/listData/ForgotPassword";
import ResendActivation from "@/components/home/listData/ResendActivation";
import HelpForm from "@/components/shared/HelpFormLoggedOut";
export default {
    components: {HeaderComponent, ForgotPassword, ResendActivation, HelpForm, FooterComponent},
    data() {
        return {
            isModalShown: false,
            isResendModalShown: false,
            Account:{
                EmailAddress:null,
                Password:null,
                salesForceId:null,
                //PortalType: this.validatePortal()
                PortalType: window.location.href.includes("championsforsight") ? "CFS" : "CLTL"
            },
            isLoginfalse:false,
            isForActivation:false,
            errorMessage:null,
            isLoginLoading: false,
            isGenericError:false,
            isHelpShown:false
        }
    },
    methods: {
        RouterRedirect(name){
            this.$router.push({name: name});
        },
         validatePortal() {
            const currentUrl = window.location.href;
            return currentUrl.includes("championsforsight") ? "CFS" : "CLTL";
        },
        ShowModal() {
            this.isModalShown = !this.isModalShown;
        },
        RedirectToSignUp(){
            this.$router.push({name: 'Registration', params: {type:'Business'}});
        },
        ShowResendModal() {
            document.body.classList.add("body-overflow");
            this.isResendModalShown = !this.isResendModalShown;
        },
        validateBeforeReview() {
            this.$validator
                .validateAll()
                .then(result => {
                   if (result == true) {
                        this.Submit();
                    } else {
                    }
                })
                .catch(() => {});
        },
        ToggleWufoo(){
            this.isHelpShown = !this.isHelpShown;
            if(this.isHelpShown){
                document.body.classList.add("body-overflow");
            }else{
                document.body.classList.remove("body-overflow");
            }
        },
        Submit() {
            var _this = this;
            _this.isLoginLoading = true;
            this.Account.PortalType = window.location.href.includes("championsforsight") ? "CFS" : "CLTL";
            axios.post('/Auth/Login', this.Account)
                .then(function (response) {
                    _this.G_ProcessLogin(response);
                    if (response.data.isSuccess == true) {
                        _this.isLoginfalse = false;
                        var targetURL = localStorage.getItem("nextURL") || "/Portal/Home"; // Default to PortalHome
                        _this.$router.push(targetURL);
                    } else {
                        var index = response.data.errorMessage.indexOf('activation');
                        _this.isLoginfalse = true;
                        if(response.data.errorMessage == "Outdated" || response.data.errorMessage == "AnnualForecastRequired"){
                          // do nothing
                        }else if(response.data.errorMessage == "GenericError"){
                          _this.isGenericError = true;
                        }else{
                          _this.errorMessage = response.data.errorMessage;
                        }
                        _this.isForActivation = index > 0;
                        _this.isLoginLoading = false;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    _this.$router.push({ name: 'Error' });
                });
        },
    }
}

</script>

<style scoped="css">
    .signin-wrapper {
        display: flex;
        justify-content: center;
        padding: 60px;
        background-color: var(--background-color);
    }
    .signin-container {
    }
    .signin-header {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// LogIn.vue?4e6f8ffa